import React from "react";
import PropTypes from "prop-types";

import { INVOICES_PAGE, DOWNGRADE_PATH } from "js/data/links";

import Link from "core/Link";
import { Section, Title, LinkContainer } from "./styles";

const SubscriptionLinks = ({
    activeUsername,
    email,
    csrf,
    paypalId,
    stripeId
}) => {
    // TODO: Grab environment from redux "config" slice once no longer on legacy page
    const isProduction =
        typeof window === "object" &&
        window._nounConfig.environment === "production";

    return (
        <Section>
            <Title>Manage Subscription</Title>
            <LinkContainer>
                <Link
                    disableVisitedStyle
                    href={INVOICES_PAGE.replace(":username", activeUsername)}
                >
                    Subscription billing history
                </Link>
            </LinkContainer>
            <LinkContainer>
                <Link
                    disableVisitedStyle
                    href="https://thenounproject.zendesk.com/hc/en-us/sections/200144558-NounPro-NounTeam-Accounts"
                    target="_blank"
                >
                    Subscription FAQs
                </Link>
            </LinkContainer>
            <LinkContainer>
                {paypalId ? (
                    <Link
                        disableVisitedStyle
                        href={`https://${
                            isProduction ? "www" : "sandbox"
                        }.paypal.com/myaccount/autopay`}
                        target="_blank"
                    >
                        Review or update subscription at PayPal
                    </Link>
                ) : (
                    <Link
                        disableVisitedStyle
                        id="cancel_pro_sub_button"
                        data-csrf={csrf}
                        data-stripe={stripeId}
                        data-email={email}
                        href={DOWNGRADE_PATH.replace(
                            ":username",
                            activeUsername
                        )}
                    >
                        Cancel subscription
                    </Link>
                )}
            </LinkContainer>
        </Section>
    );
};

SubscriptionLinks.propTypes = {
    activeUsername: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    csrf: PropTypes.string.isRequired,
    paypalId: PropTypes.string,
    stripeId: PropTypes.string
};

export default SubscriptionLinks;
